import { Stack } from '@mui/material';
import CardImageAction from 'src/features/components/cardImageAction';
import { PATH_WHATSAPP } from 'src/routes/paths';
import { StyledContainer } from './styles';

// ---------------------------------------------------------------------------

export default function Ads() {
  return (
    <Stack style={{ backgroundColor: '#f0f0f0' }}>
      <StyledContainer>
        <Stack>
          <CardImageAction
            title="Projetos personalizados para sua casa, comércio ou indústria."
            url="images/desenhoProjeto.webp"
            path={PATH_WHATSAPP}
            titleButton="Faça um orçamento sem compromisso"
          >
            A Pafesan toldos atua no mercado desde de 2013, desenvolvendo soluções em coberturas e
            metalurgia em geral em Vilhena-RO, com resultados simples e eficientes para você e sua
            casa. Garantindo qualidade e custo-benefício em diversas estruturas metálicas de
            primeira linha (direto da fábrica) com variados tipos de materiais em coberturas e
            personalizações que cabem no seu bolso.
          </CardImageAction>
        </Stack>
      </StyledContainer>
    </Stack>
  );
}
